import React from "react";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import LocaleWrapper from "./LocaleWrapper";

const queryClient = new QueryClient();

const RootElement = ({ children }: any) => {
    return (
        <QueryClientProvider client={queryClient}>
            <LocaleWrapper>{children}</LocaleWrapper>
        </QueryClientProvider>
    );
};

export default RootElement;
